import { useTranslation } from "react-i18next"
import GoalbankSelectionTemplate from "../common/GoalbankSelectionTemplate"
import { translateGradeLevel } from "utils/helpers"

const LessonPlanTemplate = ({ entity }) => {

  const { t } = useTranslation()

  
  return (
    <>
                  <b>{ t('lessons.directions-title') }:</b> { t('lessons.directions-text') }      
                  <div style={{ height: '20px' }}></div>  

                  <div>
                    <b>{ translateGradeLevel(entity.grade_level) } - { entity.subject?.title }</b>
                  </div>
                  <div style={{ marginTop: '10px' }}>
                    <b>{ entity.title }</b>
                  </div>
                  <div style={{ marginTop: '10px' }}>
                    { entity.summary }
                  </div>

                  
                  <div style={{ height: '20px' }}></div> 

                  {(entity.goalbank_selection || entity.curriculum_selection) && 
                    <GoalbankSelectionTemplate goalbankSelection={entity.goalbank_selection} curriculumSelection={entity.curriculum_selection}/>
                  }


                  <div style={{ height: '20px' }}></div>  
                  <b style={{ fontSize: '20px' }}>{t('lessons.step-two')}</b>
                  <div style={{ height: '10px' }}></div>

                  <table className="border-table"><tbody>  
                  <tr>
                      <th colSpan={2}>{ t('lessons.prior-knowledge') }</th>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        { entity.prior_knowledge }
                      </td>
                    </tr>
                    <tr>
                      <th colSpan={2}>{ t('lessons.meaning') }</th>
                    </tr>
                    <tr>
                      <td style={{ verticalAlign: 'top', width: '50%' }}>
                        <b>{ t('lessons.understandings') }:</b><br/>
                        { entity.understandings }
                      </td>
                      <td style={{ verticalAlign: 'top', width: '50%' }}>
                        <b>{ t('lessons.essential-questions') }:</b><br/>
                        { entity.essential_questions }
                      </td>
                    </tr>
                  </tbody></table>    

       
                  <div style={{ height: '20px' }}></div>
                  <b style={{ fontSize: '20px' }}>{t('lessons.step-two')}</b>
                  <div style={{ height: '10px' }}></div>      

                  <table className="border-table"><tbody>
                      <tr>
                        <th style={{ width: '25%' }}>{ t('lessons.evaluative-criteria') }</th>
                        <th>{ t('lessons.assessment-evidence-label') }</th>
                      </tr>
                      <tr>
                        <td rowSpan={2} style={{ verticalAlign: 'top', textAlign: 'center', textTransform: 'capitalize' }}>
                          { entity.assessment_type }
                        </td>
                        <td style={{ verticalAlign: 'top' }}>
                            <b>{ t('lessons.performance-task') }</b><br/>
                            { entity.assessment_evidence }
                        </td>
                      </tr> 
                      <tr>
                        <td style={{ verticalAlign: 'top' }}>
                          <b>{ t('lessons.other-evidence') }</b><br/>
                          { entity.other_evidence }
                        </td>
                      </tr>
                  </tbody></table>

                  <div style={{ height: '10px' }}></div>   

                  <table className="border-table"><tbody>
                      <tr>
                        <th style={{ width: '50%' }}>{ t('lessons.diagnostic') }</th>
                        <th style={{ width: '50%' }}>{ t('lessons.options') }</th>
                      </tr>
                      <tr>
                        <td style={{ verticalAlign: 'top', width: '50%' }}>{ entity.diagnostic }</td>
                        <td style={{ verticalAlign: 'top', width: '50%' }}>
                          <ul>
                          { entity.options.map(o => <li key={o.id}>{o.title}</li>) }
                          </ul>
                        </td>
                      </tr>
                      <tr>
                        <th colSpan={2}>{ t('lessons.specific-plan') }</th>
                      </tr>
                      <tr>
                        <td colSpan={2}>{ entity.specific_plan }</td>
                      </tr>
                  </tbody></table>

      
    </>
  )
}

export default LessonPlanTemplate
